import { Sun, Thermometer, Shield, Eye } from 'lucide-react';
const tips = [{
  icon: Sun,
  title: 'Energy Efficiency',
  description: 'Cellular shades can reduce heat gain by up to 80%, significantly lowering your cooling costs in the Arizona sun.'
}, {
  icon: Thermometer,
  title: 'UV Protection',
  description: 'Quality window treatments block up to 99% of harmful UV rays, protecting your furniture, flooring, and artwork from fading.'
}, {
  icon: Shield,
  title: 'Privacy & Security',
  description: 'Top-down/bottom-up shades allow natural light in while maintaining privacy, perfect for bedrooms and bathrooms.'
}, {
  icon: Eye,
  title: 'Light Control',
  description: 'From sheer light filtering to complete blackout, choose the right opacity for each room\'s specific needs.'
}];
export function EducationalSection() {
  return <section className="py-20 md:py-28 bg-sage-light">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 bg-sage/20 text-sage rounded-full text-sm font-medium mb-4">
            Window Treatment Guide
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Why Window Treatments Matter
          </h2>
          <p className="text-lg text-muted-foreground">
            The right window coverings do more than look beautiful. They protect your home, 
            save energy, and enhance your daily comfort.
          </p>
        </div>

        {/* Tips Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {tips.map(tip => <div key={tip.title} className="bg-card rounded-xl p-6 shadow-soft hover:shadow-medium transition-all duration-300 text-center group">
              <div className="w-16 h-16 mx-auto rounded-full bg-sage/20 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <tip.icon className="w-8 h-8 text-sage" />
              </div>
              <h3 className="font-display text-lg font-semibold text-foreground mb-3">
                {tip.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {tip.description}
              </p>
            </div>)}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-muted-foreground mb-4">
            Not sure which window treatment is right for your home?
          </p>
          <a href="#contact" className="inline-flex items-center gap-2 font-medium text-sage hover:text-sage/80 transition-colors">Schedule a free same day estimate and we'll help you choose →</a>
        </div>
      </div>
    </section>;
}